import React, { Component } from "react";
import Switch from "react-switch";
import Titulo from "../../../generico/TituloPagina";
import DatosSocio from "../../../generico/DatosSocio";
import DataTable from 'react-data-table-component';
import Popup from "react-popup";
import MensajeUsuario from "../../../generico/MensajeUsuario";
import history from "../../login/history";
import DebitoAutomaticoService from "../../../../services/autogestion/DebitoAutomaticoService";
import { trackPromise } from 'react-promise-tracker';
import { formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import CuentasDebito from "./CuentasDebito";
import ConfirmarOperacion from "./ConfirmarOperacion";
import AuthService from "../../../../services/login/auth.service";
import authService from "../../../../services/login/auth.service";
import ConfigService from "../../../../services/configuracion/ConfigService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faFloppyDisk, faPlus, faPen} from "@fortawesome/free-solid-svg-icons";


const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};

export default class DebitoAutomatico extends Component {

  constructor(props) {
    super(props);
    this.handleChangeSwitch = this.handleChangeSwitch.bind(this);
    this.getCuentasSocio = this.getCuentasSocio.bind(this);
    this.getListaDebitoAutomatico = this.getListaDebitoAutomatico.bind(this);
    this.cuenta = React.createRef();
    this.state = {
      listaDebitoAutomatico: [],
      debitos: undefined,
      columnas: this.getColumn(),
      checked: false,
      check: undefined,
      idSelect: undefined,
      cuentasOrigen: [],
      optionsCuentas: [],
      itemSelected: [],
      cuentasOrigen: [],
      tipo: undefined,
      expandir: false,
      msg_up: undefined,
      cuentaAI: undefined,
      moduloAI: undefined,
      identificadorAI: undefined,
      importeAI: undefined,
      porcentajeAI: undefined,
      disableSave: true,
    };
  }

  

  notifiPopupCambiarCuenta = (titulo, mensaje, nroOperacion, cuentaSeleccionada) =>

    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
        left: [
          {
            text: "Bajar PDF",
            className: "",
            action: function () {
              DebitoAutomaticoService.descagarComprobanteCambioCuenta(
                  "Cambio de cuenta para débitos automáticos",
                  nroOperacion,
                  AuthService.getSocio().nombreCompleto,
                  AuthService.getSocio().numeroSocio, 
                  cuentaSeleccionada, 
                )
                .then((response) => {
                  var fileURL = URL.createObjectURL(response.data);
                  window.open(fileURL, "");         
                })
                .catch(function (error) {
                  console.log(error);
                })
              Popup.close();
            },
          },
        ],
      },

    });

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });


  componentDidMount() {

    this.getListaDebitoAutomatico();

  }

  initState(){
    this.setState({ listaDebitoAutomatico: [],
      debitos: undefined,
      columnas: this.getColumn(),
      checked: false,
      check: undefined,
      idSelect: undefined,
      cuentasOrigen: [],
      optionsCuentas: [],
      itemSelected: [],
      cuentasOrigen: [],
      tipo: undefined,
      expandir: false,
      msg_up: undefined,
      cuentaAI: undefined,
      moduloAI: undefined,
      identificadorAI: undefined,
      importeAI: undefined,
      porcentajeAI: undefined,
      disableSave: true, });
  }

/**
 * HABILITAR / INHABILITAR DEBITO AUTOMATICO
 */
handleChangeSwitch(checked, event, id) {
  for (var i = 0; i < this.state.debitos.length; i++) {
    if(this.state.debitos[i].id === id){
      if (checked === true) {
        this.setState({ msg_up: "¿Desea activar el débito automático?", check: true, idSelect: id,
        cuentaAI: this.state.debitos[i].cuentaAhorro, moduloAI: this.state.debitos[i].numeroModulo, 
        identificadorAI: this.state.debitos[i].identificadorReal, importeAI: this.state.debitos[i].importeFijo, 
        porcentajeAI: this.state.debitos[i].porcentaje,
        vencimientoAI: this.state.debitos[i].vencimiento,
        identificadorFormateado: this.state.debitos[i].identificador,
        montoFormateado: this.state.debitos[i].monto,
        moduloDescripcion: this.state.debitos[i].modulo});
      } else {
        this.setState({ msg_up: "¿Desea desactivar el débito automático?", check: false, idSelect: id, 
        cuentaAI: this.state.debitos[i].cuentaAhorro, moduloAI: this.state.debitos[i].numeroModulo, 
        identificadorAI: this.state.debitos[i].identificadorReal, importeAI: this.state.debitos[i].importeFijo, 
        porcentajeAI: this.state.debitos[i].porcentaje,
        vencimientoAI: this.state.debitos[i].vencimiento,
        identificadorFormateado: this.state.debitos[i].identificador,
        montoFormateado: this.state.debitos[i].monto,
        moduloDescripcion: this.state.debitos[i].modulo});
      }
      break;
    }
  }

  this.modalCtrlConfirm.click();
}

  confirmarBtn = () => {

    trackPromise(
      DebitoAutomaticoService.habilitarInhabilitarDebito(this.state.cuentaAI, this.state.moduloAI, this.state.identificadorAI, this.state.check ? "A" : "I", this.state.importeAI, this.state.porcentajeAI)
        .then((response) => {
          var data = JSON.stringify(response.data);

          var jsonData = JSON.parse(data);
         // console.log(jsonData)
          if (jsonData.codigo === 0) {
            Popup.queue(
              this.notifiPopupDescargarComprobanteIA("Info",
                                                      jsonData.mensaje,
                                                      this.state.check ? "A" : "I",
                                                      jsonData.datos,
                                                      this.state.cuentaAI,
                                                      this.state.moduloDescripcion,
                                                      this.state.vencimientoAI,
                                                      this.state.montoFormateado,
                                                      this.state.identificadorFormateado)
            );
            this.setState({ msg_up: undefined, check: undefined, idSelect: undefined, cuentaAI: undefined, moduloAI: undefined, 
            identificadorAI: undefined, importeAI: undefined, porcentajeAI: undefined, vencimientoAI : undefined, montoFormateado: undefined, identificadorFormateado: undefined, moduloDescripcion: undefined });
            this.getListaDebitoAutomatico();

          }
          else {
            this.setState({ msg_up: undefined, check: undefined, idSelect: undefined, cuentaAI: undefined, moduloAI: undefined, 
              identificadorAI: undefined, importeAI: undefined, porcentajeAI: undefined, vencimientoAI : undefined, montoFormateado: undefined, identificadorFormateado: undefined, moduloDescripcion: undefined });
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }

        }

        ));

  }
  loadDataDebito = () => {
    //this.state.listaDebitoAutomatico
    if (this.state.debitos != undefined)
      return this.state.debitos
    else {

      return this.getListaDebitoAutomatico()
    }
  }

  loadDatosSocio = () => {
    //this.state.listaDebitoAutomatico
    if (this.state.optionsCuentas != undefined)
      return this.state.optionsCuentas
    else {

      return this.getCuentasSocio()
    }
  }

  getListaDebitoAutomatico() {
    var respuesta = [];
    trackPromise(
      DebitoAutomaticoService.obtenerDebitosSocio()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
         // console.log(jsonData)
          if (jsonData.codigo === 0) {
            var indice = 0;
            for (var i = 0; i < jsonData.datos.length; i++) {
              indice = indice + 1;
              var modulo = jsonData.datos[i].numeroModulo;
              var descModulo = jsonData.datos[i].modulo;
              var identificador = jsonData.datos[i].numeroDocumento;
              var monto = jsonData.datos[i].monto;
              if (modulo === 12)
                identificador = "-";
              if (modulo === 10) {
                descModulo = descModulo + " - " + (jsonData.datos[i].tarjeta === null ? "" : jsonData.datos[i].tarjeta)
                var nro = jsonData.datos[i].numeroDocumento;
                identificador = nro.substring(0, 4) + "****" + nro.substring(nro.length - 4, nro.length)
                if (jsonData.datos[i].porcentaje === 5)
                  monto = "Monto Mínimo"
                if (jsonData.datos[i].porcentaje === 100)
                  monto = "Saldo Cierre"
              }
              if(modulo != 10){
                monto = formatoSeparadorMilesValue(monto);
              }
              respuesta.push({
                cuentaAhorro: jsonData.datos[i].cuentaAhorro,
                identificador: identificador,
                vencimiento: jsonData.datos[i].diaVencimiento,
                modulo: descModulo,
                monto: monto,
                estado: jsonData.datos[i].estado,
                grupoRueda: jsonData.datos[i].grupoRueda,
                contrato:  jsonData.datos[i].nroContrato,
                plazo: jsonData.datos[i].cuotasPagadas,
                id: indice + "",
                situacion: jsonData.datos[i].situacion,
                importeFijo: jsonData.datos[i].montoFijo,
                porcentaje: jsonData.datos[i].porcentaje,
                numeroModulo: modulo,
                identificadorReal: jsonData.datos[i].identificador,
              });
            }
            this.setState({ debitos: respuesta, expandir: false });
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        }
        ));
    return this.state.debitos;
  }

  getColumn() {
    return [
      {
        name: "Cuenta de Ahorro",
        selector: row => row.cuentaAhorro,
      },
      {
        name: "Identificador",
        selector: row => row.identificador
      },
      {
        name: "Día Vencimiento",
        selector: row => row.vencimiento,
        width: "10px"
      },
      {
        name: "Módulo",
        selector: row => row.modulo,
        width: "250px"
      },
      {
        name: "Grupo",
        selector: row => row.grupoRueda,
        width: "120px"
      },
      {
        name: "Nro. Contrato",
        selector: row => row.contrato,
        width: "120px"
      },
      {
        name: "Plazo",
        selector: row => row.plazo,
        width: "80px"
      },
      {
        name: "Monto",
        selector: row => row.monto,
        right: true,
        width: "150px"
      },
      {
        name: "Estado",
        selector: row => row.estado
      },
      {
        cell: (row) => (
          <Switch id={row.id}
            onChange={this.handleChangeSwitch}
            checked={row.situacion === 'A'}
            height={15} width={40} uncheckedIcon={false}
            checkedIcon={false} handleDiameter={22} className="react-switch"
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            onColor="#EAAC24" />
        ),
        width: "100px",
      },
    ];
  }
/**
 * CAMBIO DE CUENTA A DEBITAR
 */
  guardarCambioCuenta() {
    //// cierra el formulario
    var formulario = document.getElementById("collapse");
    formulario.classList.remove("show");
    trackPromise(
      DebitoAutomaticoService.confirmarCambioCuenta(this.state.cuentaOrigenSelected)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigo === 0) {
            /*this.getListaDebitoAutomatico()
            this.getCuentasSocio();*/
            this.initState()
            Popup.queue(
              this.notifiPopupCambiarCuenta(
                "Confirmar",
                jsonData.mensaje,
                jsonData.datos,
                this.state.cuentaOrigenSelected
              )
            );
         
          }
          else {

            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        }
        ));
  }

  agregarDebito = (e) => {
    //history.push('/agregarDebito');
    history.push(ConfigService.getPathByName("agregarDebito")?.url);
    window.location.reload();
  }

  getCuentasSocio() {
    var options = [];
    trackPromise(
      DebitoAutomaticoService.obtenerCuentasDebitoSocio()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          
         // console.log(response.data)
          if (jsonData.codigo === 0) {
            for (var i = 0; i < jsonData.datos.length; i++) {
              options.push({
                value: jsonData.datos[i].idAhorro,
                label:
                  jsonData.datos[i].idAhorro +
                  "-" +
                  jsonData.datos[i].descripcion +
                  "-" +
                  " Saldo: " +
                  formatoSeparadorMilesValue(jsonData.datos[i].saldoTotal) + " " +
                  jsonData.datos[i].idMoneda +
                  ".",
              });
            }
            this.setState({ cuentasOrigen: jsonData.datos, optionsCuentas: options, tipo: undefined, expandir: true });

          }
          else {
            //// cierra el formulario
            var formulario = document.getElementById("collapse");
            formulario.classList.remove("show");
            this.setState({ expandir: false });
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        }
        ));
    //console.log(options)
    return options;
  }

  selectorValue = (dataFromChild, item) => {
    if (dataFromChild === undefined) {
      this.setState({
        cuentaOrigenSelected: undefined,
        cuentaDebito: undefined,
        saldoActual: undefined,
        detalleCuenta: undefined,
        itemSelected: undefined,
        disableSave: true
      });
      return
    }
    this.setState({
      cuentaOrigenSelected: dataFromChild,
      cuentaDebito: dataFromChild.cuenta,
      saldoActual: dataFromChild.saldoActual,
      detalleCuenta: dataFromChild.cuenta + " " + dataFromChild.denominacion,
      itemSelected: item,
      disableSave: false
    });

  };
  montoValue = (dataFromChild) => {
    this.setState({
      monto: dataFromChild,
    });
  };

  notifiPopupDescargarComprobanteIA = (titulo,mensaje,tipoIA, nroOperacion, cuentaAhorro, tipo, vencimiento, monto, identificador) =>
  Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
          },
        },
      ],
      left: [
        {
          text: "Bajar PDF",
          className: "",
          action: function () {
            DebitoAutomaticoService.descagarComprobanteIA(
                tipoIA,
                nroOperacion,
                AuthService.getSocio().nombreCompleto,
                AuthService.getSocio().numeroSocio, 
                cuentaAhorro,
                tipo,
                vencimiento,
                monto,
                identificador
              )
              .then((response) => {
                var fileURL = URL.createObjectURL(response.data);
                window.open(fileURL, "");         
              })
              .catch(function (error) {
                console.log(error);
              })
            Popup.close();
          },
        },
      ],
    },

  });

  render() {
    if (this.state.debitos === undefined)
      this.getListaDebitoAutomatico();
    var cuentas = this.loadDatosSocio();

    return (
      <div className="content-wrapper">
        <ConfirmarOperacion
          idModal="idModalConfirm"
          title="Confirmar Operación"
          mensaje={this.state.msg_up}

          confirmarBtn={this.confirmarBtn.bind(this)}
        />
        <Titulo texto="Débitos Automáticos" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <DatosSocio />
                  </div>
                  <div className="card-body">
                    <div className="row">
                    <div className="col-lg-6 col-md-2 col-12"></div>
                    <div className="col-lg-3 col-md-5 col-12">
                    <button className="btn btn-cu-primary btn-consulta" onClick={this.agregarDebito}>
                       <FontAwesomeIcon icon={faPlus} />   Agregar Débito
                          </button>
                    </div>
                    <div className="col-lg-3 col-md-5 col-12">
                    <button className="btn btn-cu-secundary" onClick={this.getCuentasSocio}
                          data-toggle="collapse" data-target="#collapse" aria-expanded={this.state.expandir} aria-controls="collapse">
                          <FontAwesomeIcon icon={faPen} />  Cambiar Cuenta de Debito
                        </button>
                    </div>

                    </div>
                    <br />
                    <div className="row">
                      <div className="col-md-12">
                        <div className="collapse" id="collapse">
                          <div className="card">
                            <div className="card-body">
                              <div className="row">
                              
                                <div className="col-lg-6 col-md-7">
                                
                                  {<CuentasDebito titulo="Seleccione la Cuenta Origen (a debitar)" ref="cuenta" presentacion="SELECT" selectorValue={this.selectorValue.bind(this)} itemSelected={this.state.tipo} cuentas={cuentas} />}

                                </div>
                                <div className="col-lg-6 col-md-5" style={{display:"grid", alignItems:"center"}}>
                                <button disabled={this.state.disableSave} className="btn btn-cu-primary" onClick={() => this.guardarCambioCuenta()}  ><FontAwesomeIcon icon={faFloppyDisk} /> Guardar</button>

                                </div>
                              </div>
                              <hr />
                              <div className="row">
                                <div className="col-md-12">
                                  <MensajeUsuario tipo="INFO"
                                    titulo="Observación."
                                    mensaje="Los débitos automáticos activos con las misma moneda de la cuenta seleccionada serán cambiados." />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-md-12">
                        <label className="input-label-bold">
                          Débitos Automáticos Seleccionados
                          </label>
                        <div className="table-responsive">
                          <DataTable
                            noHeader={true}
                            pagination={true}
                            columns={this.getColumn()}
                            data={this.state.debitos}
                            dense={true}
                            pagination={true}
                            paginationComponentOptions={paginationOptions}
                            noDataComponent="no hay registros para mostrar"
                            striped={true} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <a
          ref={(a) => (this.modalCtrlConfirm = a)}
          href="#"
          hidden
          id="modalCtrlConfirm"
          data-toggle="modal"
          data-target="#idModalConfirm"
        ></a>
      </div>
    );
  }
}
